import { createAsyncThunk } from '@reduxjs/toolkit'
import RestClient from '../../../services/client/RestClient'
import Configuration from '../../../services/api/Configuration'

const getDepartmentsApi = Configuration.Departments_Endpoints.departments

const retrieveDepartments = createAsyncThunk('departments/getDepartments', async ({ queries }) => {
  const res = await RestClient.getRequest(
    `${getDepartmentsApi}`,
    queries && {
      headers: {
        tenant_id: queries,
      },
    },
  )
  return res.data
})

export default retrieveDepartments
